"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PKPNFTData = void 0;
exports.PKPNFTData = {
    date: '2023-11-14T15:45:41Z',
    address: '0x58582b93d978F30b4c4E812A16a7b31C035A69f7',
    contractName: 'PKPNFT',
    abi: [
        {
            inputs: [
                {
                    internalType: 'bytes4',
                    name: '_selector',
                    type: 'bytes4',
                },
            ],
            name: 'CannotAddFunctionToDiamondThatAlreadyExists',
            type: 'error',
        },
        {
            inputs: [
                {
                    internalType: 'bytes4[]',
                    name: '_selectors',
                    type: 'bytes4[]',
                },
            ],
            name: 'CannotAddSelectorsToZeroAddress',
            type: 'error',
        },
        {
            inputs: [
                {
                    internalType: 'bytes4',
                    name: '_selector',
                    type: 'bytes4',
                },
            ],
            name: 'CannotRemoveFunctionThatDoesNotExist',
            type: 'error',
        },
        {
            inputs: [
                {
                    internalType: 'bytes4',
                    name: '_selector',
                    type: 'bytes4',
                },
            ],
            name: 'CannotRemoveImmutableFunction',
            type: 'error',
        },
        {
            inputs: [
                {
                    internalType: 'bytes4',
                    name: '_selector',
                    type: 'bytes4',
                },
            ],
            name: 'CannotReplaceFunctionThatDoesNotExists',
            type: 'error',
        },
        {
            inputs: [
                {
                    internalType: 'bytes4',
                    name: '_selector',
                    type: 'bytes4',
                },
            ],
            name: 'CannotReplaceFunctionWithTheSameFunctionFromTheSameFacet',
            type: 'error',
        },
        {
            inputs: [
                {
                    internalType: 'bytes4[]',
                    name: '_selectors',
                    type: 'bytes4[]',
                },
            ],
            name: 'CannotReplaceFunctionsFromFacetWithZeroAddress',
            type: 'error',
        },
        {
            inputs: [
                {
                    internalType: 'bytes4',
                    name: '_selector',
                    type: 'bytes4',
                },
            ],
            name: 'CannotReplaceImmutableFunction',
            type: 'error',
        },
        {
            inputs: [
                {
                    internalType: 'uint8',
                    name: '_action',
                    type: 'uint8',
                },
            ],
            name: 'IncorrectFacetCutAction',
            type: 'error',
        },
        {
            inputs: [
                {
                    internalType: 'address',
                    name: '_initializationContractAddress',
                    type: 'address',
                },
                {
                    internalType: 'bytes',
                    name: '_calldata',
                    type: 'bytes',
                },
            ],
            name: 'InitializationFunctionReverted',
            type: 'error',
        },
        {
            inputs: [
                {
                    internalType: 'address',
                    name: '_contractAddress',
                    type: 'address',
                },
                {
                    internalType: 'string',
                    name: '_message',
                    type: 'string',
                },
            ],
            name: 'NoBytecodeAtAddress',
            type: 'error',
        },
        {
            inputs: [
                {
                    internalType: 'address',
                    name: '_facetAddress',
                    type: 'address',
                },
            ],
            name: 'NoSelectorsProvidedForFacetForCut',
            type: 'error',
        },
        {
            inputs: [
                {
                    internalType: 'address',
                    name: '_user',
                    type: 'address',
                },
                {
                    internalType: 'address',
                    name: '_contractOwner',
                    type: 'address',
                },
            ],
            name: 'NotContractOwner',
            type: 'error',
        },
        {
            inputs: [
                {
                    internalType: 'address',
                    name: '_facetAddress',
                    type: 'address',
                },
            ],
            name: 'RemoveFacetAddressMustBeZeroAddress',
            type: 'error',
        },
        {
            anonymous: false,
            inputs: [
                {
                    components: [
                        {
                            internalType: 'address',
                            name: 'facetAddress',
                            type: 'address',
                        },
                        {
                            internalType: 'enum IDiamond.FacetCutAction',
                            name: 'action',
                            type: 'uint8',
                        },
                        {
                            internalType: 'bytes4[]',
                            name: 'functionSelectors',
                            type: 'bytes4[]',
                        },
                    ],
                    indexed: false,
                    internalType: 'struct IDiamond.FacetCut[]',
                    name: '_diamondCut',
                    type: 'tuple[]',
                },
                {
                    indexed: false,
                    internalType: 'address',
                    name: '_init',
                    type: 'address',
                },
                {
                    indexed: false,
                    internalType: 'bytes',
                    name: '_calldata',
                    type: 'bytes',
                },
            ],
            name: 'DiamondCut',
            type: 'event',
        },
        {
            inputs: [
                {
                    components: [
                        {
                            internalType: 'address',
                            name: 'facetAddress',
                            type: 'address',
                        },
                        {
                            internalType: 'enum IDiamond.FacetCutAction',
                            name: 'action',
                            type: 'uint8',
                        },
                        {
                            internalType: 'bytes4[]',
                            name: 'functionSelectors',
                            type: 'bytes4[]',
                        },
                    ],
                    internalType: 'struct IDiamond.FacetCut[]',
                    name: '_diamondCut',
                    type: 'tuple[]',
                },
                {
                    internalType: 'address',
                    name: '_init',
                    type: 'address',
                },
                {
                    internalType: 'bytes',
                    name: '_calldata',
                    type: 'bytes',
                },
            ],
            name: 'diamondCut',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'bytes4',
                    name: '_functionSelector',
                    type: 'bytes4',
                },
            ],
            name: 'facetAddress',
            outputs: [
                {
                    internalType: 'address',
                    name: 'facetAddress_',
                    type: 'address',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [],
            name: 'facetAddresses',
            outputs: [
                {
                    internalType: 'address[]',
                    name: 'facetAddresses_',
                    type: 'address[]',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'address',
                    name: '_facet',
                    type: 'address',
                },
            ],
            name: 'facetFunctionSelectors',
            outputs: [
                {
                    internalType: 'bytes4[]',
                    name: '_facetFunctionSelectors',
                    type: 'bytes4[]',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [],
            name: 'facets',
            outputs: [
                {
                    components: [
                        {
                            internalType: 'address',
                            name: 'facetAddress',
                            type: 'address',
                        },
                        {
                            internalType: 'bytes4[]',
                            name: 'functionSelectors',
                            type: 'bytes4[]',
                        },
                    ],
                    internalType: 'struct IDiamondLoupe.Facet[]',
                    name: 'facets_',
                    type: 'tuple[]',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            anonymous: false,
            inputs: [
                {
                    indexed: true,
                    internalType: 'address',
                    name: 'previousOwner',
                    type: 'address',
                },
                {
                    indexed: true,
                    internalType: 'address',
                    name: 'newOwner',
                    type: 'address',
                },
            ],
            name: 'OwnershipTransferred',
            type: 'event',
        },
        {
            inputs: [],
            name: 'owner',
            outputs: [
                {
                    internalType: 'address',
                    name: 'owner_',
                    type: 'address',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'address',
                    name: '_newOwner',
                    type: 'address',
                },
            ],
            name: 'transferOwnership',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
        },
        {
            inputs: [],
            name: 'CallerNotOwner',
            type: 'error',
        },
        {
            anonymous: false,
            inputs: [
                {
                    indexed: true,
                    internalType: 'address',
                    name: 'owner',
                    type: 'address',
                },
                {
                    indexed: true,
                    internalType: 'address',
                    name: 'approved',
                    type: 'address',
                },
                {
                    indexed: true,
                    internalType: 'uint256',
                    name: 'tokenId',
                    type: 'uint256',
                },
            ],
            name: 'Approval',
            type: 'event',
        },
        {
            anonymous: false,
            inputs: [
                {
                    indexed: true,
                    internalType: 'address',
                    name: 'owner',
                    type: 'address',
                },
                {
                    indexed: true,
                    internalType: 'address',
                    name: 'operator',
                    type: 'address',
                },
                {
                    indexed: false,
                    internalType: 'bool',
                    name: 'approved',
                    type: 'bool',
                },
            ],
            name: 'ApprovalForAll',
            type: 'event',
        },
        {
            anonymous: false,
            inputs: [
                {
                    indexed: false,
                    internalType: 'address',
                    name: 'newResolverAddress',
                    type: 'address',
                },
            ],
            name: 'ContractResolverAddressSet',
            type: 'event',
        },
        {
            anonymous: false,
            inputs: [
                {
                    indexed: true,
                    internalType: 'address',
                    name: 'newFreeMintSigner',
                    type: 'address',
                },
            ],
            name: 'FreeMintSignerSet',
            type: 'event',
        },
        {
            anonymous: false,
            inputs: [
                {
                    indexed: false,
                    internalType: 'uint8',
                    name: 'version',
                    type: 'uint8',
                },
            ],
            name: 'Initialized',
            type: 'event',
        },
        {
            anonymous: false,
            inputs: [
                {
                    indexed: false,
                    internalType: 'uint256',
                    name: 'newMintCost',
                    type: 'uint256',
                },
            ],
            name: 'MintCostSet',
            type: 'event',
        },
        {
            anonymous: false,
            inputs: [
                {
                    indexed: true,
                    internalType: 'uint256',
                    name: 'tokenId',
                    type: 'uint256',
                },
                {
                    indexed: false,
                    internalType: 'bytes',
                    name: 'pubkey',
                    type: 'bytes',
                },
            ],
            name: 'PKPMinted',
            type: 'event',
        },
        {
            anonymous: false,
            inputs: [
                {
                    indexed: true,
                    internalType: 'address',
                    name: 'from',
                    type: 'address',
                },
                {
                    indexed: true,
                    internalType: 'address',
                    name: 'to',
                    type: 'address',
                },
                {
                    indexed: true,
                    internalType: 'uint256',
                    name: 'tokenId',
                    type: 'uint256',
                },
            ],
            name: 'Transfer',
            type: 'event',
        },
        {
            anonymous: false,
            inputs: [
                {
                    indexed: false,
                    internalType: 'uint256',
                    name: 'amount',
                    type: 'uint256',
                },
            ],
            name: 'Withdrew',
            type: 'event',
        },
        {
            inputs: [
                {
                    internalType: 'address',
                    name: 'to',
                    type: 'address',
                },
                {
                    internalType: 'uint256',
                    name: 'tokenId',
                    type: 'uint256',
                },
            ],
            name: 'approve',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'address',
                    name: 'owner',
                    type: 'address',
                },
            ],
            name: 'balanceOf',
            outputs: [
                {
                    internalType: 'uint256',
                    name: '',
                    type: 'uint256',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'uint256',
                    name: 'tokenId',
                    type: 'uint256',
                },
            ],
            name: 'burn',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'uint256',
                    name: 'keyType',
                    type: 'uint256',
                },
                {
                    internalType: 'bytes32',
                    name: 'derivedKeyId',
                    type: 'bytes32',
                },
                {
                    components: [
                        {
                            internalType: 'bytes32',
                            name: 'r',
                            type: 'bytes32',
                        },
                        {
                            internalType: 'bytes32',
                            name: 's',
                            type: 'bytes32',
                        },
                        {
                            internalType: 'uint8',
                            name: 'v',
                            type: 'uint8',
                        },
                    ],
                    internalType: 'struct IPubkeyRouter.Signature[]',
                    name: 'signatures',
                    type: 'tuple[]',
                },
            ],
            name: 'claimAndMint',
            outputs: [
                {
                    internalType: 'uint256',
                    name: '',
                    type: 'uint256',
                },
            ],
            stateMutability: 'payable',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'uint256',
                    name: 'tokenId',
                    type: 'uint256',
                },
            ],
            name: 'exists',
            outputs: [
                {
                    internalType: 'bool',
                    name: '',
                    type: 'bool',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [],
            name: 'freeMintSigner',
            outputs: [
                {
                    internalType: 'address',
                    name: '',
                    type: 'address',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'uint256',
                    name: 'tokenId',
                    type: 'uint256',
                },
            ],
            name: 'getApproved',
            outputs: [
                {
                    internalType: 'address',
                    name: '',
                    type: 'address',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'uint256',
                    name: 'tokenId',
                    type: 'uint256',
                },
            ],
            name: 'getEthAddress',
            outputs: [
                {
                    internalType: 'address',
                    name: '',
                    type: 'address',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [],
            name: 'getNextDerivedKeyId',
            outputs: [
                {
                    internalType: 'bytes32',
                    name: '',
                    type: 'bytes32',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [],
            name: 'getPkpNftMetadataAddress',
            outputs: [
                {
                    internalType: 'address',
                    name: '',
                    type: 'address',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [],
            name: 'getPkpPermissionsAddress',
            outputs: [
                {
                    internalType: 'address',
                    name: '',
                    type: 'address',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'uint256',
                    name: 'tokenId',
                    type: 'uint256',
                },
            ],
            name: 'getPubkey',
            outputs: [
                {
                    internalType: 'bytes',
                    name: '',
                    type: 'bytes',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [],
            name: 'getRouterAddress',
            outputs: [
                {
                    internalType: 'address',
                    name: '',
                    type: 'address',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [],
            name: 'getStakingAddress',
            outputs: [
                {
                    internalType: 'address',
                    name: '',
                    type: 'address',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [],
            name: 'initialize',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'address',
                    name: 'owner',
                    type: 'address',
                },
                {
                    internalType: 'address',
                    name: 'operator',
                    type: 'address',
                },
            ],
            name: 'isApprovedForAll',
            outputs: [
                {
                    internalType: 'bool',
                    name: '',
                    type: 'bool',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [],
            name: 'mintCost',
            outputs: [
                {
                    internalType: 'uint256',
                    name: '',
                    type: 'uint256',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'uint256',
                    name: 'keyType',
                    type: 'uint256',
                },
                {
                    internalType: 'bytes',
                    name: 'ipfsCID',
                    type: 'bytes',
                },
            ],
            name: 'mintGrantAndBurnNext',
            outputs: [
                {
                    internalType: 'uint256',
                    name: '',
                    type: 'uint256',
                },
            ],
            stateMutability: 'payable',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'uint256',
                    name: 'keyType',
                    type: 'uint256',
                },
            ],
            name: 'mintNext',
            outputs: [
                {
                    internalType: 'uint256',
                    name: '',
                    type: 'uint256',
                },
            ],
            stateMutability: 'payable',
            type: 'function',
        },
        {
            inputs: [],
            name: 'name',
            outputs: [
                {
                    internalType: 'string',
                    name: '',
                    type: 'string',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'uint256',
                    name: 'tokenId',
                    type: 'uint256',
                },
            ],
            name: 'ownerOf',
            outputs: [
                {
                    internalType: 'address',
                    name: '',
                    type: 'address',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'bytes32',
                    name: 'hash',
                    type: 'bytes32',
                },
            ],
            name: 'prefixed',
            outputs: [
                {
                    internalType: 'bytes32',
                    name: '',
                    type: 'bytes32',
                },
            ],
            stateMutability: 'pure',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'uint256',
                    name: 'tokenId',
                    type: 'uint256',
                },
            ],
            name: 'redeemedFreeMintIds',
            outputs: [
                {
                    internalType: 'bool',
                    name: '',
                    type: 'bool',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'address',
                    name: 'from',
                    type: 'address',
                },
                {
                    internalType: 'address',
                    name: 'to',
                    type: 'address',
                },
                {
                    internalType: 'uint256',
                    name: 'tokenId',
                    type: 'uint256',
                },
            ],
            name: 'safeTransferFrom',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'address',
                    name: 'from',
                    type: 'address',
                },
                {
                    internalType: 'address',
                    name: 'to',
                    type: 'address',
                },
                {
                    internalType: 'uint256',
                    name: 'tokenId',
                    type: 'uint256',
                },
                {
                    internalType: 'bytes',
                    name: 'data',
                    type: 'bytes',
                },
            ],
            name: 'safeTransferFrom',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'address',
                    name: 'operator',
                    type: 'address',
                },
                {
                    internalType: 'bool',
                    name: 'approved',
                    type: 'bool',
                },
            ],
            name: 'setApprovalForAll',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'address',
                    name: 'newResolverAddress',
                    type: 'address',
                },
            ],
            name: 'setContractResolver',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'address',
                    name: 'newFreeMintSigner',
                    type: 'address',
                },
            ],
            name: 'setFreeMintSigner',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'uint256',
                    name: 'newMintCost',
                    type: 'uint256',
                },
            ],
            name: 'setMintCost',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'bytes4',
                    name: 'interfaceId',
                    type: 'bytes4',
                },
            ],
            name: 'supportsInterface',
            outputs: [
                {
                    internalType: 'bool',
                    name: '',
                    type: 'bool',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [],
            name: 'symbol',
            outputs: [
                {
                    internalType: 'string',
                    name: '',
                    type: 'string',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'uint256',
                    name: 'index',
                    type: 'uint256',
                },
            ],
            name: 'tokenByIndex',
            outputs: [
                {
                    internalType: 'uint256',
                    name: '',
                    type: 'uint256',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'address',
                    name: 'owner',
                    type: 'address',
                },
                {
                    internalType: 'uint256',
                    name: 'index',
                    type: 'uint256',
                },
            ],
            name: 'tokenOfOwnerByIndex',
            outputs: [
                {
                    internalType: 'uint256',
                    name: '',
                    type: 'uint256',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'uint256',
                    name: 'tokenId',
                    type: 'uint256',
                },
            ],
            name: 'tokenURI',
            outputs: [
                {
                    internalType: 'string',
                    name: '',
                    type: 'string',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [],
            name: 'totalSupply',
            outputs: [
                {
                    internalType: 'uint256',
                    name: '',
                    type: 'uint256',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'address',
                    name: 'from',
                    type: 'address',
                },
                {
                    internalType: 'address',
                    name: 'to',
                    type: 'address',
                },
                {
                    internalType: 'uint256',
                    name: 'tokenId',
                    type: 'uint256',
                },
            ],
            name: 'transferFrom',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
        },
        {
            inputs: [],
            name: 'withdraw',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
        },
    ],
};
//# sourceMappingURL=PKPNFTData.js.map